/**
 * Роль-зависимые URL сущностей (маршрут / заявка) без смены роутинга:
 * query `tab` для вкладок карточек, согласованных с RouteCardPage и ApplicationDetails.
 */
export type DashboardRoleKind = 'logist' | 'accountant' | 'management' | 'other';

export function dashboardRoleKind(roleName: string | null | undefined): DashboardRoleKind {
  const r = String(roleName || '').trim().toLowerCase();
  if (r === 'accountant' || r === 'finance') return 'accountant';
  if (r === 'admin' || r === 'manager' || r === 'director') return 'management';
  if (r === 'logist' || r === 'dispatcher') return 'logist';
  return 'other';
}

/** Вкладка по умолчанию на карточке маршрута (`RouteCardPage`). */
export function routeDefaultTabKey(kind: DashboardRoleKind): string {
  if (kind === 'accountant') return 'finance';
  return 'card';
}

/** Вкладка по умолчанию на карточке заявки (`ApplicationDetailsPanel`). */
export function applicationDefaultTabKey(kind: DashboardRoleKind): string {
  if (kind === 'accountant') return 'finance';
  return 'main';
}

export function routeCardPath(routeId: number, kind: DashboardRoleKind): string {
  const tab = routeDefaultTabKey(kind);
  return `/routes/${routeId}?tab=${encodeURIComponent(tab)}`;
}

export function applicationCardPath(applicationId: number, kind: DashboardRoleKind): string {
  const tab = applicationDefaultTabKey(kind);
  return `/applications/${applicationId}?tab=${encodeURIComponent(tab)}`;
}
